var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        [
          !_vm.isCapturable()
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("global.messages.warning.ordenRequerido")
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCapturable()
            ? _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.fechaInicioBeca"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaInicioBeca",
                                  placeholder: "",
                                  max: new Date(),
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value:
                                    _vm.solicitud.beca.periodoBeca
                                      .fechaInicioBeca,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud.beca.periodoBeca,
                                      "fechaInicioBeca",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.beca.periodoBeca.fechaInicioBeca",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.fechaFinBeca"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaFinBeca",
                                  placeholder: "",
                                  max: new Date(),
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value:
                                    _vm.solicitud.beca.periodoBeca.fechaFinBeca,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud.beca.periodoBeca,
                                      "fechaFinBeca",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.beca.periodoBeca.fechaFinBeca",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.duracionBeca"
                                ),
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "duracionBecaMeses",
                                  disabled: "",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.duracionBecaMeses,
                                  callback: function ($$v) {
                                    _vm.duracionBecaMeses = $$v
                                  },
                                  expression: "duracionBecaMeses",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.fechaInicioMovilidad"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaInicioMovilidad",
                                  placeholder: "",
                                  "value-as-date": false,
                                  disabled: !(
                                    _vm.solicitud.estado === "EN_CAPTURA"
                                  ),
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value: _vm.solicitud.fechaInicioMovilidad,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "fechaInicioMovilidad",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.fechaInicioMovilidad",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.fechaFinMovilidad"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaFinMovilidad",
                                  placeholder: "",
                                  "value-as-date": false,
                                  disabled: !(
                                    _vm.solicitud.estado === "EN_CAPTURA"
                                  ),
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value: _vm.solicitud.fechaFinMovilidad,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "fechaFinMovilidad",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.fechaFinMovilidad",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.duracionMovilidadMesesDias"
                                ),
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "duracionMovilidadMesesDias",
                                  disabled: "",
                                  size: "sm",
                                },
                                model: {
                                  value:
                                    _vm.solicitud.duracionMovilidadMesesDias,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "duracionMovilidadMesesDias",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.duracionMovilidadMesesDias",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.inicioPeriodoMovilidad"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "inicioPeriodoMovilidad",
                                  placeholder: "",
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value: _vm.solicitud.inicioPeriodoMovilidad,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "inicioPeriodoMovilidad",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.inicioPeriodoMovilidad",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.finPeriodoMovilidad"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  ñ: "",
                                  id: "finPeriodoMovilidad",
                                  placeholder: "",
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value: _vm.solicitud.finPeriodoMovilidad,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "finPeriodoMovilidad",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.finPeriodoMovilidad",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasMovilidad.label.duracionMovilidad"
                                ),
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "duracionMovilidadMeses",
                                  disabled: "",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.solicitud.duracionMovilidadMeses,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "duracionMovilidadMeses",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.duracionMovilidadMeses",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.periodosDeApoyos.length > 0
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3 mb-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", lg: "6" } },
                            [
                              _c("h5", [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.fechasMovilidad.label.periodosOtorgados"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                _vm._l(
                                  _vm.periodosDeApoyos,
                                  function (periodo) {
                                    return _c(
                                      "b-list-group-item",
                                      { key: periodo.id },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("span", {
                                                  class: {
                                                    "text-danger":
                                                      _vm.mesesAcumuladosConEstaSolicitud >
                                                        _vm.mesesMaximosTotales &&
                                                      periodo.indicadorActual,
                                                    "text-success":
                                                      _vm.mesesAcumuladosConEstaSolicitud <=
                                                        _vm.mesesMaximosTotales &&
                                                      periodo.indicadorActual,
                                                  },
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      periodo.periodo
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                periodo.indicadorActual
                                                  ? _c(
                                                      "b-badge",
                                                      {
                                                        attrs: {
                                                          variant: "primary",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.$t(
                                                                "apeironGwApp.fechasMovilidad.label.periodoEstaSolicitud"
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", lg: "6" } },
                            [
                              _c("h5", [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.fechasMovilidad.label.detallesDePeriodos"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                [
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.mesesMaximosTotales
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.fechasMovilidad.label.mesesDisponiblesBeca"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.mesesDisponiblesParaEstaSolicitud
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.fechasMovilidad.label.mesesDisponiblesSolicitud"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.mesesAcumuladosSinEstaSolicitud
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.fechasMovilidad.label.mesesAnterioresOtorgados"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "text-danger":
                                                    _vm.mesesAcumuladosConEstaSolicitud >
                                                    _vm.mesesMaximosTotales,
                                                  "text-success":
                                                    _vm.mesesAcumuladosConEstaSolicitud <=
                                                    _vm.mesesMaximosTotales,
                                                },
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.mesesAcumuladosConEstaSolicitud
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.fechasMovilidad.label.mesesAnterioresOtorgadosYActualEnProceso"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.mesesDisponiblesSinEstaSolicitud
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.fechasMovilidad.label.mesesDisponiblesSinEstaSolicitud"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.mesesDisponiblesConEstaSolicitud
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.fechasMovilidad.label.mesesDisponiblesConEstaSolicitud"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm.showNotaMeses
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-alert",
                                { attrs: { show: "", variant: "warning" } },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.showMessage),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCapturable()
        ? _c(
            "b-col",
            { attrs: { md: "2" } },
            [
              _vm.solicitud.beca
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        id: "refrescar",
                        variant: "primary",
                        block: "",
                        disabled: !(
                          _vm.solicitud.estado === "EN_CAPTURA" &&
                          _vm.solicitud.fechaFinMovilidad
                        ),
                      },
                      on: { click: _vm.confirmaPeriodoChange },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "apeironGwApp.fechasMovilidad.label.confirmarPeriodo"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "save" }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }